<template>
    <div>
        <div class="img_container" @click = " index = 0 ">
            <div class="nieco">
                <div class="up">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 13L9 9L13 13ZM10.3333 5.66667C10.3333 6.2795 10.2126 6.88634 9.97811 7.45252C9.74358 8.01871 9.39984 8.53316 8.9665 8.9665C8.53316 9.39984 8.01871 9.74358 7.45252 9.97811C6.88634 10.2126 6.2795 10.3333 5.66667 10.3333C5.05383 10.3333 4.447 10.2126 3.88081 9.97811C3.31462 9.74358 2.80018 9.39984 2.36683 8.9665C1.93349 8.53316 1.58975 8.01871 1.35523 7.45252C1.12071 6.88634 1 6.2795 1 5.66667C1 4.42899 1.49167 3.242 2.36683 2.36683C3.242 1.49167 4.42899 1 5.66667 1C6.90434 1 8.09133 1.49167 8.9665 2.36683C9.84167 3.242 10.3333 4.42899 10.3333 5.66667Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <img class="image" :src=imgs[0]>
        </div>
        <vue-gallery-slideshow :images="imgs" :index="index" @close="index = null"></vue-gallery-slideshow>
    </div>
</template>

<script>
    import VueGallerySlideshow from 'vue-gallery-slideshow';
    export default {
        props: ['files'],
        components: {
            VueGallerySlideshow,
        },
        data() {
            return {
                showLightbox: false,
                imgs: [],
                visible: false,
                index: 0,
                images: [],
                index: null
                
            }
        },
        created () {
            this.images = JSON.parse(this.files);
            this.images.forEach(img => {
                this.imgs.push("/img/entry_images/"+img.filename);
            });
        },
        methods: {
            openLightbox () {
                this.showLightbox = true
                this.$refs.lightbox.showImage(1)
            },
            changeImage (index) {
            },
            showImg (index) {
                this.index = index
                this.visible = true
            },
            handleHide () {
                this.visible = false
            }
        }
    }
</script>
<style lang="scss">
.vgs__gallery{
    display: none !important;
}
.vgs{
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}
.vgs__container{
    background: transparent !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    margin: 0 auto !important;
    width: auto !important;
    max-width: 90vw !important;
    height: auto !important;
    max-height: 80vh !important;
}
.vgs__container__img{
    width: auto !important;
    height: auto !important;
    max-width: 90vw !important;
    max-height: 80vh !important;
    object-fit: contain !important;
}
</style>
<style lang="scss" scoped>
     .img_container {
        @media screen and (max-width: 990px) {
                margin: 0 0 16px 0;
                width: 100%;
                height: 200px;
                border-radius: 12px;
                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        }
        border-radius: 8px;
        position: relative;
        width: 130px;
        height: 113px;
        overflow: hidden;
        margin-right:28px;
        cursor: pointer;
        .nieco{
            background: rgba(0, 0, 0,.5);
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
            z-index: 10;
            .up{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
                svg{
                    z-index: 11;
                    width: 20px;
                    height: 20px;
                    path{
                        &:hover{
                            stroke: #f2f2f2;
                        }
                    }
                }
            }
            &:hover{
                background: rgba(0, 0, 0,.4); 
            }
        }
        .image{
            position: absolute;
            max-width: 100%;
            width: auto;
            height: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 9;
            @media screen and (max-width: 990px) {
                width: 100%;
                height: 100%;
                object-fit: cover;
                max-width: none;
            }
        }
        @media screen and (max-width: 990px) {
            .nieco .up svg{
                width: 28px;
                height: 28px;
            }
        }
     }

</style>